import getWithToken from './base/get-with-token'

const getDataImportDashboard = getWithToken(`/customer-list-import-dashboard`)

export default getDataImportDashboard
